import { Box, useMediaQuery } from "@mui/material";
import { mainModelData } from "../services/modelsData";
import { theme } from "../styles/mui-theme";

export const MainModelAtom = () => {
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      component={"img"}
      src={mainModelData[0].imgSrc}
      alt="background"
      sx={{
        height: "100%",
        objectFit: "contain",
        objectPosition: "bottom",
        zIndex: 10,
      }}
    />
  );
};
